import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

export interface ICancelSubscriptionResponse {
  message: string;
  cancel_at_period_end: boolean;
  current_period_end: string;
}

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();
  const { refreshUser } = useAuth();

  return useMutation<ICancelSubscriptionResponse, Error, { immediate: boolean; reason?: string }>({
    mutationFn: async (payload: { immediate: boolean; reason?: string }) => {
      return await httpService.post<ICancelSubscriptionResponse>(
        API_CONFIG.path.stripeCancel,
        payload as unknown as Record<string, unknown>
      );
    },
    onSuccess: () => {
      refreshUser();
      queryClient.invalidateQueries({ queryKey: ["stripe", "history"] });
    },
  });
};
